export const SIGN_IN = 'SING_IN';
export const SIGN_OUT = 'SING_OUT';
export const AUTH_FAIL = 'AUTH_FAIL';

export const SET_TODOS = 'SET_TODOS';
export const ADD_TODO = 'ADD_TODO';
export const EDIT_TODO = 'EDIT_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const DELETE_ALL_TODO = 'DELETE_ALL_TODO';
export const COMPLETE_TODO = 'COMPLETE_TODO';
export const SET_EDIT_TODO = 'SET_EDIT_TODO';
export const SET_FILTER_TODO  = 'SET_FILTER_TODO';
export const TOGGLE_ROW_COLOR = 'TOGGLE_ROW_COLOR';

